import { gql } from "@apollo/client";

export const CreateInstalledBaseNode = gql`
    mutation CreateInstalledBaseNode (
        $parentNodeId: ID!,
        $input: InstalledBaseNodeCreateAttributesInput!,
        $attributes: [InstalledBaseCustomAttributeInput!]
    ){
        createInstalledBaseNode(
            parentNodeId: $parentNodeId,
            input: $input,
            attributes: $attributes
        ){
            id
        }
    }
`;